export default __webpack_public_path__ + "static/img_logo-7cbacfa54b2edfd68bf2ce7b3a9d6e8b.png";